// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"index_pageTitle_1Kyjh","cardTitle":"index_cardTitle_3chzI","filledBtn":"index_filledBtn_10ITt","requiredMark":"index_requiredMark_hyxP4","stripe0":"index_stripe0_2x4Ra","stripe1":"index_stripe1_y6TtF","stripe":"index_stripe_11RxK","list-name":"index_list-name_1vI4F"};
    if(module.hot) {
      // 1788760850752
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":true});
      module.hot.dispose(cssReload);
      
    }
  